<template>
  <div>
    <!-- Overlay -->
    <div class="overlay" @click="closeDialog"></div>

    <!-- Modal Content -->
    <div class="modal-content text-start">
      <h1 class="title text-center">{{ $t("Models.MailingModel.title") }}</h1>
      <span> {{ $t("Models.MailingModel.lineOne") }}</span>
      <div class="d-flex flex-column">
        <span>
          {{ $t("Models.MailingModel.lineTwo") }}
          <br /><strong
            >"{{ $t("Models.MailingModel.singedToMailing") }}"</strong
          >.</span
        >
        <span> {{ $t("Models.MailingModel.lineThree") }}</span>
      </div>
      <span> {{ $t("Models.MailingModel.lineFour") }}</span>
      <div
        class="buttons-action d-flex flex-column align-center ga-2 justify-center mt-4"
      >
        <v-checkbox
          v-model="isUserApprovedMailing"
          hide-details
          :label="$t('Models.MailingModel.singedToMailing')"
          color="#4fb989"
        ></v-checkbox>
        <span class="loading-checkbox" v-if="isLoading">
          {{ $t("Models.loading") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["closeModel"],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isUserApprovedMailing: false,
    };
  },
  watch: {
    isUserApprovedMailing() {
      this.closeDialog();
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeModel", this.isUserApprovedMailing);
    },
  },
};
</script>

<style lang="scss">
.buttons-action {
  .v-checkbox .v-selection-control {
    min-height: fit-content;
  }
  .v-checkbox {
    background-color: $primaryColorlight;
    border: 1px solid $greenColor;
    border-radius: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;
  }
  .v-label {
    color: $greenColor;
    font-weight: 500;
  }
}
</style>

<style lang="scss" scoped>
.title {
  color: $greenColor;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.modal-content {
  display: flex;
  flex-direction: column;
  max-width: 540px;
  width: 90%;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);

  span {
    color: $secondaryTextColor;
  }
}

.loading-checkbox {
  color: $greenColor !important;
}
</style>
